import { internalApiRequest } from '@/shared/services/apiService';

export const createInvitation = (data) => {
  return internalApiRequest({
    method: 'POST',
    path: 'api/v1/invitations',
    data,
  });
};

export const resendMemberInvitation = (invitationId) => {
  return internalApiRequest({
    method: 'POST',
    path: `api/v1/invitations/${invitationId}/resend`,
  });
};

export const updateWorkspaceMemberInvitationSettings = (invitationId, data) => {
  return internalApiRequest({
    method: 'PUT',
    path: `api/v1/invitations/${invitationId}`,
    data,
  });
};

export const deleteWorkspaceMemberInvitation = (invitationId) => {
  return internalApiRequest({
    method: 'DELETE',
    path: `api/v1/invitations/${invitationId}`,
  });
};

export const updateWorkspaceMemberSettings = (workspaceId, memberId, data) => {
  return internalApiRequest({
    method: 'PUT',
    path: `api/v1/workspaces/${workspaceId}/allowedusers/${memberId}`,
    data,
  });
};

export const deleteWorkspaceMember = (workspaceId, memberId) => {
  return internalApiRequest({
    method: 'DELETE',
    path: `api/v1/workspaces/${workspaceId}/allowedusers/${memberId}`,
  });
};
